import type { PreviewFacts, PreviewBeat } from "./preview-copy.types";
export function ladderScoringPhrase(f: PreviewFacts): string | null {
  return f.scoring === null
    ? null
    : f.scoring.slice(
        0,
        f.scoring.indexOf(" · ") === -1 ? undefined : f.scoring.indexOf(" · "),
      );
}
export function formattedScoreLabel(scoreLabel: string | null): string {
  if (!scoreLabel) return "score";

  return /^[a-z]+$/.test(scoreLabel) && scoreLabel.length <= 4
    ? scoreLabel.toUpperCase()
    : scoreLabel;
}
export function beat0GetStarted(f: PreviewFacts): PreviewBeat {
  return {
    title: "Press Play",
    body: `Use the chat box to tell your AI coding assistant how you want to play ${f.name}. It writes a bot that plays matches for you.`,
  };
}
function scoreClause(f: PreviewFacts): string {
  const label = formattedScoreLabel(f.scoreLabel);
  const isGenericScore = (f.scoreLabel ?? "score").toLowerCase() === "score";
  const phrase = ladderScoringPhrase(f);
  return !phrase ? label : isGenericScore ? phrase : `${label} (${phrase})`;
}
function beat1TheMatch(f: PreviewFacts): PreviewBeat {
  const seats = f.seats ?? f.numAgents;
  const score = scoreClause(f);
  const seatsText = seats ? `${seats} players` : "Players";
  return {
    title: "The match",
    body: `${seatsText} take a seat in each episode of ${f.name}; the standings rank them by ${score}.`,
  };
}
function beat2YourPoliciesMove(f: PreviewFacts): PreviewBeat {
  if (f.playerTypes?.includes("file") && f.playerTypes.includes("container")) {
    return {
      title: "The program plays",
      body: `Your program is a file the game runs or a container that answers each tick, and both compete together.${f.playerTypes.includes("human") ? " People can join through league lobbies." : ""}`,
    };
  }

  if (f.playerTypes?.includes("file")) {
    return {
      title: "The program plays",
      body: `Your program is a file ${f.name} runs for the whole match, with no live input from you.`,
    };
  }

  return {
    title: "The program plays",
    body: `Your program answers every tick of ${f.name} on its own, so you stay off the controls.`,
  };
}
export function beatCoachIt(): PreviewBeat {
  return {
    title: "Improve your bot",
    body: `After each match, review your bot's score and tell your AI coding assistant what to change for the next match.`,
  };
}
export function templateBeats(f: PreviewFacts): PreviewBeat[] {
  return [
    beat0GetStarted(f),
    beat1TheMatch(f),
    beat2YourPoliciesMove(f),
    beatCoachIt(),
  ];
}
